import React, { useState, useContext, useRef, useEffect } from "react";
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import AudioPop from "../../timelineSetting/audioPop";
import MyContext from "../../../../context/MyContext";
import ProjectContext from "../../../../context/ProjectContext";
import TickerContext from "../../../../context/ticker";
import Deleteicon from "@mui/icons-material/DeleteForever";

const DragHandle = sortableHandle(() => (
  <div
    className="material-icons "
    style={{ fontSize: "20px", marginTop: "6px" }}
  >
    menu
  </div>
));

const SortableItem = SortableElement(
  ({
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    setitems,
    items,
    value,
    popShow,
    setpopShow,
    setAudioKey,
    CurrentIndex,
    setCurrentIndex,
    AudioKey,
    
  }) => {
    const {clone, seteditableObject, setisTextInputOrAreaFocus } =
      useContext(MyContext);
    const { LayersData, setLayersData } = useContext(ProjectContext);

    const handleClick = (
      e,
      show,
      set,
      key,
      setAudioKey,
      setCurrentIndex,
      AudioKey
    ) => {
      var Parentoffset =
        e.target.offsetParent.offsetParent.offsetParent.offsetParent.getBoundingClientRect();
      Parentoffset = Parentoffset.top;
      var targetOffset = e.target.getBoundingClientRect();
      targetOffset = targetOffset.top;

      var currentPosition = targetOffset - Parentoffset;
      setCurrentIndex(currentPosition);

      if (show === true) {
        if (AudioKey === key) {
          set(false);
        } else {
          set(true);
          setAudioKey(key);
        }
      } else {
        set(true);
        setAudioKey(key);
      }
    };

    function lockLayer(setitem, item, key) {
      const array = Array.from(item);

      for (var i = 0; i < array.length; i++) {
        if (array[i].key === key) {
          array[i].layerlock = true;
          array[i].lock = true;
          array[i].Editable = true;
          array[i].showDiv = false;
          array[i].Added = true;
        } else {
          array[i].Editable = false;
          array[i].Added = true;
        }
      }

      setitem(array);
    }

    function unlockLayer(setitem, item, key) {
      const array = Array.from(item);

      for (var i = 0; i < array.length; i++) {
        if (array[i].key === key) {
          array[i].layerlock = false;
          array[i].lock = false;
          array[i].Editable = true;
          array[i].showDiv = true;
          array[i].toolbar = true;
          array[i].Added = true;
        } else {
          array[i].Editable = false;
          array[i].showDiv = false;
          array[i].toolbar = false;
          array[i].Added = true;
        }
      }

      setitem(array.reverse());
    }

    function hideLayer(value, setitem, item, key) {
      var array = [];
      array = Array.from(item);

      for (var i = 0; i < array.length; i++) {
        if (array[i].key === key) {
          array[i].hidden = true;
          array[i].opc = 0.5;
          array[i].Editable = false;
          array[i].showDiv = false;
          array[i].Added = false;
        } else {
          array[i].Added = true;
        }
      }
      setitem(array.reverse());
    }

    function unhideLayer(value, setitem, item, key) {
      var array = [];
      array = Array.from(item).reverse();
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === key) {
          array[i].hidden = false;
          array[i].opc = 1;
          array[i].Added = true;
        } else {
          array[i].Added = true;
        }
      }

      setitem(array);
    }

    const Activelayer = (setitem, item, key, e) => {
      // debugger
      if (
        e.target.id == "delete" ||
        (e.target.ownerSVGElement && e.target.ownerSVGElement.id == "delete") ||
        e.target.innerText == "visibility" ||
        e.target.innerText == "visibility_off"
      ) {
        return;
      }

      const array = Array.from(item);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === key) {
          if (!array[i].lock) {
            array[i].Editable = true;
            array[i].showDiv = true;
            array[i].toolbar = true;
          }
        } else {
          array[i].Editable = false;
          array[i].showDiv = false;
          array[i].toolbar = false;
        }
      }

      setitem(array.reverse());
      seteditableObject({ showPanel: true, editableItem: value });
    };
    const deleteLayer = () => {
     
    };

    return (
      <div
        onClick={(e) => Activelayer(setitems, items, value.key, e)}
        className="visi"
        style={{
          zIndex: 2147483647,
          display: "flex !important",
          flexDirection: "row",
        }}
      >
        <div
          id="layerPanelWrapperInsider"
          className="layerPanelWrapperInsider"
          style={{ opacity: value.opc }}
        >
          <div className="layerPanelInsider">
            {value.Editable && (
              <div
                className="layerPanelSection sideActiveMenuInner"
                style={{
                  height: "31px",
                  minWidth: "198px",
                  width: "100%",
                  alignItems: "center",
                  display: "flex",
                  verticalAlign: "ceter",
                  position: "relative",
                }}
              >
                <div className="sideActiveMenu" id="sideActiveMenu"></div>

                {value.layerlock === false && (
                  <div className="layerPanelLeft">
                    <div className="layerPanelLeftIcon">
                      <DragHandle />
                    </div>
                  </div>
                )}

                {value.layerlock === true && (
                  <div className="layerPanelLeftLocked">
                    <div className="layerPanelLeftIcon">
                      <div
                        className="material-icons "
                        style={{ fontSize: "20px", marginTop: "6px" }}
                      >
                        menu
                      </div>
                    </div>
                  </div>
                )}

                <div className="layerPanelCenter">
                  <div className="layerPanelCenterSvg">
                    <span
                      className="material-icons "
                      style={{
                        fontSize: "15px",
                        marginTop: "8px",
                        marginLeft: "8px",
                      }}
                    >
                      {value.typeIcon}
                    </span>
                  </div>
                  <NameChange value={value} />
                </div>

                <div className="layerOptions">
                  {value.type === "audio" && (
                    <div
                      className="layerHide"
                      onClick={(event) =>
                        handleClick(
                          event,
                          popShow,
                          setpopShow,
                          value.key,
                          setAudioKey,
                          setCurrentIndex,
                          AudioKey
                        )
                      }
                    >
                      <div className="material-icons smallerIcon layericonRelative">
                        settings
                      </div>
                    </div>
                  )}

                  {value.layerlock === false && (
                    <div
                      className="layerHide"
                      onClick={() =>
                        lockLayer(
                          setitems,
                          items,
                          value.key,
                          setRedoLayer,
                          UndoLayer,
                          setUndoLayer
                        )
                      }
                    >
                      <div className="material-icons smallerIcon layericonRelative">
                        lock_open
                      </div>
                    </div>
                  )}

                  {value.layerlock === true && (
                    <div
                      className="layerHide"
                      onClick={() =>
                        unlockLayer(
                          setitems,
                          items,
                          value.key,
                          setRedoLayer,
                          UndoLayer,
                          setUndoLayer
                        )
                      }
                    >
                      <div className="material-icons smallerIcon layericonRelative">
                        lock
                      </div>
                    </div>
                  )}

                  {value.hidden === false && (
                    <div
                      className="layerHide"
                      onClick={() =>
                        hideLayer(
                          value,
                          setitems,
                          items,
                          value.key,
                          setRedoLayer,
                          UndoLayer,
                          setUndoLayer
                        )
                      }
                    >
                      <div className="material-icons smallerIcon layericonRelative">
                        visibility
                      </div>
                    </div>
                  )}

                  {value.hidden === true && (
                    <div
                      className="layerHide"
                      onClick={() =>
                        unhideLayer(
                          value,
                          setitems,
                          items,
                          value.key,
                          setRedoLayer,
                          UndoLayer,
                          setUndoLayer
                        )
                      }
                    >
                      <div className="material-icons smallerIcon layericonRelative">
                        visibility_off
                      </div>
                    </div>
                  )}

                  <div
                    id="delete"
                    onClick={(event) => {
                      let stack = [...UndoLayer];
                      let PrevArray = clone(LayersData);
                  
                      if (stack.length < 10) {
                        stack.push(PrevArray);
                        setUndoLayer(stack);
                        setRedoLayer([]);
                      } else {
                        stack.shift();
                        stack.push(PrevArray);
                        setUndoLayer(stack);
                        setRedoLayer([]);
                      }
                      //event.stopPropagation()
                      const array = Array.from(LayersData);
                      for (var i = 0; i < array.length; i++) {
                        if (array[i].key === value.key) {
                          array.splice(i, 1);
                          break;
                        }
                      }
                      setLayersData(array);
                   
                    }}
                    className="layerHide"
                  >
                    <Deleteicon
                      id="delete"
                      style={{ marginTop: "-1px" }}
                      fontSize="small"
                    />
                  </div>
                </div>
              </div>
            )}

            {!value.Editable && (
              <div
                className="layerPanelSection"
                style={{
                  height: "31px",
                  minWidth: "198px",
                  width: "100%",
                  alignItems: "center",
                  display: "flex",
                  verticalAlign: "ceter",
                  position: "relative",
                }}
              >
                {value.layerlock === false && (
                  <div
                    className="layerPanelLeft"
                    style={{
                      alignItems: "center",
                      height: "100%",
                      marginRight: "5px",
                      marginLeft: "8px",
                    }}
                  >
                    <div className="layerPanelLeftIcon">
                      <DragHandle />
                    </div>
                  </div>
                )}

                {value.layerlock === true && (
                  <div className="layerPanelLeftLocked">
                    <div className="layerPanelLeftIcon">
                      <div className="material-icons smallerIcon2">menu</div>
                    </div>
                  </div>
                )}

                <div
                  className="layerPanelCenter"
                  onClick={(e) => Activelayer(setitems, items, value.key, e)}
                >
                  <div className="layerPanelCenterSvg">
                    <span
                      className="material-icons "
                      style={{
                        fontSize: "15px",
                        marginTop: "8px",
                        marginLeft: "8px",
                      }}
                    >
                      {value.typeIcon}
                    </span>
                  </div>

                  <div
                    className="layerPanelTittle"
                    style={{ display: "inline-block", position: "absolute" }}
                  >
                    <div className="layerPanelTittleText">
                      <div
                        className=" "
                        style={{
                          fontSize: "11px",
                          height: "19px",
                          marginTop: "8px",
                          display: "inline-block",
                          maxWidth: "78px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          verticalAlign: "center",
                        }}
                      >
                        {value.Name}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="layerOptions">
                  {value.type === "audio" && (
                    <div
                      className="layerHide "
                      onClick={(event) =>
                        handleClick(
                          event,
                          popShow,
                          setpopShow,
                          value.key,
                          setAudioKey,
                          setCurrentIndex,
                          AudioKey
                        )
                      }
                    >
                      <div className="material-icons smallerIcon layericonRelative">
                        settings
                      </div>
                    </div>
                  )}

                  {value.layerlock === false && (
                    <div
                      className="layerHide "
                      onClick={() =>
                        lockLayer(
                          setitems,
                          items,
                          value.key,
                          setRedoLayer,
                          UndoLayer,
                          setUndoLayer
                        )
                      }
                    >
                      <div className="material-icons smallerIcon layericonRelative">
                        lock_open
                      </div>
                    </div>
                  )}

                  {value.layerlock === true && (
                    <div
                      className="layerHide"
                      onClick={() =>
                        unlockLayer(
                          setitems,
                          items,
                          value.key,
                          setRedoLayer,
                          UndoLayer,
                          setUndoLayer
                        )
                      }
                    >
                      <div className="material-icons smallerIcon layericonRelative">
                        lock
                      </div>
                    </div>
                  )}

                  {value.hidden === false && (
                    <div
                      className="layerHide"
                      onClick={() =>
                        hideLayer(
                          value,
                          setitems,
                          items,
                          value.key,
                          setRedoLayer,
                          UndoLayer,
                          setUndoLayer
                        )
                      }
                    >
                      <div className="material-icons smallerIcon layericonRelative">
                        visibility
                      </div>
                    </div>
                  )}

                  {value.hidden === true && (
                    <div
                      className="layerHide"
                      onClick={() =>
                        unhideLayer(
                          value,
                          setitems,
                          items,
                          value.key,
                          setRedoLayer,
                          UndoLayer,
                          setUndoLayer
                        )
                      }
                    >
                      <div className="material-icons smallerIcon layericonRelative">
                        visibility_off
                      </div>
                    </div>
                  )}

                  <div
                    id="delete"
                    onClick={(event) => {
                      let stack = [...UndoLayer];
                      let PrevArray = clone(LayersData);
                  
                      if (stack.length < 10) {
                        stack.push(PrevArray);
                        setUndoLayer(stack);
                        setRedoLayer([]);
                      } else {
                        stack.shift();
                        stack.push(PrevArray);
                        setUndoLayer(stack);
                        setRedoLayer([]);
                      }
                      //event.stopPropagation();
                      const array = Array.from(LayersData);
                      for (var i = 0; i < array.length; i++) {
                        if (array[i].key === value.key) {
                          array.splice(i, 1);
                          break;
                        }
                      }
                      setLayersData(array);
                      setitems(array);
                    }}
                    className="layerHide"
                  >
                    <Deleteicon
                      id="delete"
                      style={{ marginTop: "-1px" }}
                      fontSize="small"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
);

const SortableList = SortableContainer(
  ({
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    AudioKey,
    items,
    popShow,
    setpopShow,
    setAudioKey,
    CurrentIndex,
    setCurrentIndex,
    setitems,
  }) => {
    return (
      <div>
        {items.map((value, index) => (
          <>
            <SortableItem
              setRedoLayer={setRedoLayer}
              UndoLayer={UndoLayer}
              setUndoLayer={setUndoLayer}
              setitems={setitems}
              items={items}
              index={index}
              AudioKey={AudioKey}
              CurrentIndex={CurrentIndex}
              setCurrentIndex={setCurrentIndex}
              setAudioKey={setAudioKey}
              popShow={popShow}
              setpopShow={setpopShow}
              key={index.toString()}
              value={value}
            />
          </>
        ))}
      </div>
    );
  }
);

export const LayerPanel = (props) => {
  const {
    LayersData,
    setLayersData,
    setRedoLayer,
    clone,
    UndoLayer,
    ChangeCount,
    setChangeCount,
    setUndoLayer,
    CanvasDisplay,
    setCanvasDisplay,
    editableObject,
    setpopShow,
    popShow,
  } = useContext(MyContext);

  const { ReverseLayer } = useContext(TickerContext);
  const [AudioKey, setAudioKey] = useState(0);

  const [CurrentIndex, setCurrentIndex] = useState(null);
  const [values, setvalues] = useState(editableObject.editableItem);
  const Scroller = useRef(null);

  const handlelayersScrolling = (e) => {
    var mediaLayer = document.getElementsByClassName("mediaStyleWrapper")[0];
    if (e.deltaY > 0) {
      let scrollTop = Scroller.current.scrollTop;
      Scroller.current.scroll(0, scrollTop + 10);
      let scrollLeft = mediaLayer.scrollLeft;
      mediaLayer.scroll(scrollLeft, scrollTop + 10);
    } else {
      let scrollTop = Scroller.current.scrollTop;
      Scroller.current.scroll(0, scrollTop - 10);
      let scrollLeft = mediaLayer.scrollLeft;
      mediaLayer.scroll(scrollLeft, scrollTop - 10);
    }
  };
    // useEffect(() =>{

    // },[LayersData])
  const StackStore = () => {
    let stack = [...UndoLayer];
    let PrevArray = clone(reverseArr(ReverseLayer));

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }
  };

  function reverseArr(input) {
    var ret = new Array();
    for (var i = input.length - 1; i >= 0; i--) {
      ret.push(input[i]);
    }
    return ret;
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    StackStore();

    let converter = arrayMove(ReverseLayer, oldIndex, newIndex);
    //const array = Array.from(converter);

    //converter.reverse();

    setLayersData(converter.reverse());
    setChangeCount(ChangeCount + 1);
    if (document.getElementsByClassName("basicShapeIdentityClass").length > 0) {
      //This is fix for basic shapes svg not resizing in ratio after sorting.
      for (
        var i = 0;
        i < document.getElementsByClassName("basicShapeIdentityClass").length;
        i++
      ) {
        document
          .getElementsByClassName("basicShapeIdentityClass")
          [i].children[0].setAttribute("preserveAspectRatio", "none");
        console.log(
          document.getElementsByClassName("basicShapeIdentityClass")[i]
            .children[0]
        );
      }
    }
  };

  const onSortStart = (e) => {
    if (!CanvasDisplay) {
      setCanvasDisplay(true);
    }
  };

  return (
    <div className="layerPanel">
      {popShow === true && (
        <AudioPop
          value={values}
          CurrentPosition={CurrentIndex}
          popShow={popShow}
          setLayersData={props.setLayersData}
          LayersData={LayersData}
          AudioKey={AudioKey}
          setpopShow={setpopShow}
        />
      )}
      <div className="layerPanelWrapper">
        <div
          ref={Scroller}
          className="layerPanelWrapperScroll"
          onWheel={(event) => handlelayersScrolling(event)}
        >
          <SortableList
            key={"SortableList-2"}
            setRedoLayer={setRedoLayer}
            UndoLayer={UndoLayer}
            setUndoLayer={setUndoLayer}
            CurrentIndex={CurrentIndex}
            setCurrentIndex={setCurrentIndex}
            AudioKey={AudioKey}
            setAudioKey={setAudioKey}
            setpopShow={setpopShow}
            popShow={popShow}
            setitems={setLayersData}
            items={ReverseLayer}
            onSortStart={onSortStart}
            onSortEnd={onSortEnd}
            useDragHandle
            lockAxis={"y"}
          />
        </div>
      </div>
    </div>
  );
};

export default LayerPanel;

const NameChange = ({ value }) => {
  const { setLayersData, LayersData } = useContext(MyContext);

  const [ChangeName, setChangeName] = useState(false);

  const [Name, setName] = useState(value.Name);

  const Textblur = (params) => {
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === value.key) {
        array[i].Name = Name;
      }
    }
    setLayersData(array);
    setChangeName(false);
  };

  const NameChange = (params) => {
    if (params.key === "Enter") {
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === value.key) {
          array[i].Name = Name;
        }
      }
      setLayersData(array);
      setChangeName(false);
    }
  };
  return (
    <>
      {ChangeName === false && (
        <div
          className="layerPanelTittle"
          style={{ display: "inline-block", position: "absolute" }}
        >
          <div
            className="layerlabel "
            style={{
              fontSize: "11px",
              height: "19px",
              marginTop: "8px",
              display: "inline-block",
              maxWidth: "78px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              verticalAlign: "center",
            }}
            onDoubleClick={() => setChangeName(true)}
          >
            {value.Name}
          </div>
        </div>
      )}

      {ChangeName === true && (
        <div className="layerPanelTittle">
          <div className="layerlabel ">
            <input
              type="text"
              autoFocus
              style={{ width: "78px" }}
              onBlur={(event) => {
                Textblur(event);
                //setisTextInputOrAreaFocus(false);
              }}
              onKeyDown={(event) => NameChange(event)}
              value={Name}
              onChange={(e) => setName(e.target.value)}
              //onFocus={() => //setisTextInputOrAreaFocus(true)}
            />
          </div>
        </div>
      )} 
    </>
  );
};
